export default "__VITE_ASSET__BH9YF4pB__"